import React, { useState } from 'react';
import { login as loginRequest } from '../api'; // поправь путь при необходимости

const Login = ({ onLogin }) => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');
    setIsLoading(true);

    try {
      await loginRequest({ login, password });
      onLogin();
    } catch (e) {
      setError(e.message || 'Неверный логин или пароль');
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !isLoading) {
      handleSubmit();
    }
  };

  const containerStyle = {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #f5f9ff, #eef7ff)'
  };

  const panelStyle = {
    background: '#fff',
    padding: '30px',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    minWidth: '280px'
  };

  const titleStyle = {
    fontSize: '20px',
    fontWeight: 700,
    color: '#004DCF',
    textAlign: 'center'
  };

  const inputStyle = {
    padding: '10px',
    borderRadius: '10px',
    border: '1px solid #004DCF33',
    outline: 'none'
  };

  const buttonStyle = {
    padding: '10px',
    borderRadius: '10px',
    border: 'none',
    background: '#004DCF',
    color: '#fff',
    fontWeight: 600,
    cursor: isLoading ? 'default' : 'pointer',
    opacity: isLoading ? 0.7 : 1
  };

  const errorStyle = {
    color: 'red',
    fontSize: '14px',
    textAlign: 'center'
  };

  return (
    <div style={containerStyle}>
      <div style={panelStyle}>
        <div style={titleStyle}>Авторизация</div>

        <input
          placeholder="Логин"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          onKeyDown={handleKeyDown}
          style={inputStyle}
        />

        <input
          type="password"
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          style={inputStyle}
        />

        <button
          onClick={handleSubmit}
          style={buttonStyle}
          disabled={isLoading}
        >
          {isLoading ? 'Входим...' : 'Войти'}
        </button>

        {error && <div style={errorStyle}>{error}</div>}
      </div>
    </div>
  );
};

export default Login;